var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"my-4"},[_vm._v(_vm._s(_vm.$t('SYSTEM_REGISTRATION')))]),_c('RegistrationForm',{attrs:{"onSubmit":_vm.register}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }